import { Pipe, PipeTransform } from '@angular/core';
import { Tracker } from '../entities/index';

declare let moment: any;

@Pipe({
  name: 'isActiveTracker'
})
export class IsActiveTrackerPipe implements PipeTransform {
  transform(tracker: Tracker): boolean {
    if (!tracker || !tracker.id) {
      return false;
    }

    if (!tracker.expiration_date) {
      return true;
    }

    if (moment(tracker.expiration_date).toDate() >= (new Date())) {
      return true;
    }

    return false;
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/pipes/is-active-tracker.pipe.ts